import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateApprove = async ({
  communityId,
  budgetId,
  reason,
}: {
  communityId: string;
  budgetId: string;
  reason: string;
}) => {
  return await axiosAuth.post(
    `${BUDGET(communityId)}/${budgetId}/approve?reason=${encodeURIComponent(reason)}`
  );
};

const useApproveMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateApprove,
    ...queryParams,
  });

export default useApproveMutation;